export const getCookie = function(name) {
  const cookies = document.cookie.split('; ');
  for (let i = 0; i < cookies.length; i++) {
    const [key, value] = cookies[i].split('=');
    if (key === name) return decodeURIComponent(value);
  }
  return undefined;
}

//TS version for later refactor
// export const getCookie = (name: string): string | null => {
//   const nameEQ = encodeURIComponent(name) + "=";
//   const cookiesArray = document.cookie.split('; ');

//   for (let cookie of cookiesArray) {
//     if (cookie.startsWith(nameEQ)) {
//       return decodeURIComponent(cookie.substring(nameEQ.length));
//     }
//   }

//   return null; // Return null if the cookie is not found
// };